import { Component, Injector, OnInit } from "@angular/core";
import { Visitor } from "../visitor";
import { Filter, FilterComponent, FilterOptions } from "@mango/core";

interface VisitorFormModel extends Visitor {
  startDate: Date;
  endDate: Date;
}

@Component({
  selector: "app-visitor-filter",
  templateUrl: "./visitor-filter.component.html",
  styleUrls: ["./visitor-filter.component.css"],
})
export class VisitorFilterComponent extends FilterComponent<
  Visitor,
  VisitorFormModel
> {
  constructor(injector: Injector) {
    super(
      injector,
      Visitor,
      new FilterOptions<Visitor, VisitorFormModel>()
        .atLeast("registerTime", "startDate")
        .atMost("registerTime", "endDate")
    );
  }
}
